import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';
const Header = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

  return (
    <>
      <header className="header">
        <div className="logo">
          <span className="logo-text">Classic <span className="logo-accent">Fence &amp; Deck</span></span>
        </div>
        <div className="menu-icon" onClick={toggleSidebar}>&#9776;</div>
        <nav className="nav-menu">
          <Link to="/">Home</Link>
          <Link to="/projects">Our Work</Link>
          <Link to="/reviews">Reviews</Link>
          <Link to="/contact">Contact</Link>
          <Link to="/contact" className="estimate-btn">Free Estimate</Link>
        </nav>
      </header>

      <div className={`sidebar ${sidebarOpen ? 'open' : ''}`}>
        <button className="close-btn" onClick={toggleSidebar}>&times;</button>
        <Link to="/" onClick={toggleSidebar}>Home</Link>
        <Link to="/projects" onClick={toggleSidebar}>Our Work</Link>
        <Link to="/reviews" onClick={toggleSidebar}>Reviews</Link>
        <Link to="/contact" onClick={toggleSidebar}>Contact</Link>
        <Link to="/contact" className="sidebar-estimate" onClick={toggleSidebar}>Free Estimate</Link>
      </div>
      <div className={`backdrop ${sidebarOpen ? 'open' : ''}`} onClick={toggleSidebar}></div>
    </>
  );
};

export default Header;
